import creditEngineRepository, { CreditEngineRepository } from './CreditEngineRepository'

const resource = '/lender';
export default {
  getAllowedAddressProofsList(loanId) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(`${resource}/loan/${loanId}/allowedAddressProofs`)
  },

  getEmployerList(loanId,querySearch) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(`${resource}/employer/list/${loanId}/${querySearch}`)
  },

  getCoBrandingConfig(lenderName) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}/public/config/${lenderName}`)
  }

}
